import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import { VehiclesPage, VehicleDetail } from "@/pages/Vehicles";
import Bookings from "@/pages/Bookings";
import { RentalsPage, RentalDetail } from "@/pages/Rentals";
import { CustomersPage, CustomerDetail } from "@/pages/Customers";
import Employees from "@/pages/Employees";
import { PaymentsPage, DeadlinesPage, MaintenancesPage } from "@/pages/Operations";
import DocumentsPage from "@/pages/Documents";
import Reports from "@/pages/Reports";
import Support from "@/pages/Support";
import InvoicingPage from "@/pages/Invoicing";
import SettingsPage from "@/pages/Settings";
import ImportHistory from "@/pages/ImportHistory";
import { PlatformHome, CompanySettingsPage } from "@/pages/Settings";
import BillingActivate from "@/pages/BillingActivate";
import PlanChangePay from "@/pages/PlanChangePay";
import ResetPassword from "@/pages/ResetPassword";
import DemoAccess from "@/pages/DemoAccess";
import ActivationRequest from "@/pages/ActivationRequest";

function Protected() {
  const { state } = useAuth();
  const loc = useLocation();
  if (state === null) return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin text-zinc-500" /></div>;
  if (!state) return <Navigate to="/login" replace />;
  if (state.platform && !(loc.pathname.startsWith("/piattaforma") || loc.pathname === "/impostazioni" || loc.pathname === "/fatture")) return <Navigate to="/piattaforma" replace />;
  if (!state.platform && loc.pathname.startsWith("/piattaforma")) return <Navigate to="/" replace />;
  return <Layout />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reimposta-password" element={<ResetPassword />} />
          <Route path="/demo" element={<DemoAccess />} />
          <Route path="/richiesta-attivazione" element={<ActivationRequest />} />
          <Route path="/registrazione-societa" element={<ActivationRequest />} />
          <Route path="/attiva/:token" element={<BillingActivate />} />
          <Route path="/cambio-piano/:token" element={<PlanChangePay />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/veicoli" element={<VehiclesPage />} />
            <Route path="/veicoli/:id" element={<VehicleDetail />} />
            <Route path="/calendario" element={<Bookings />} />
            <Route path="/prenotazioni" element={<Bookings />} />
            <Route path="/noleggi" element={<RentalsPage />} />
            <Route path="/noleggi/:id" element={<RentalDetail />} />
            <Route path="/clienti" element={<CustomersPage />} />
            <Route path="/clienti/:id" element={<CustomerDetail />} />
            <Route path="/dipendenti" element={<Employees />} />
            <Route path="/pagamenti" element={<PaymentsPage />} />
            <Route path="/scadenze" element={<DeadlinesPage />} />
            <Route path="/manutenzioni" element={<MaintenancesPage />} />
            <Route path="/documenti" element={<DocumentsPage />} />
            <Route path="/report" element={<Reports />} />
            <Route path="/assistenza" element={<Support />} />
            <Route path="/fatture" element={<InvoicingPage />} />
            <Route path="/impostazioni" element={<SettingsPage />} />
            <Route path="/piattaforma" element={<PlatformHome />} />
            <Route path="/piattaforma/societa/:id" element={<CompanySettingsPage />} />
            <Route path="/importazioni" element={<ImportHistory />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" theme="dark" />
    </AuthProvider>
  );
}
